var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8823 12.8462V11.2748H30V12.8462H24.8823ZM26.6006 23L22.5063 19.9538L23.4935 18.7088L27.5875 21.755L26.6006 23ZM23.3715 5.29118L22.3847 4.04621L26.4787 1L27.4655 2.24496L23.3715 5.29118ZM5.20367 21.4286V15.445H3.55864C2.85004 15.445 2.24638 15.1977 1.74767 14.7032C1.24922 14.2085 1 13.6097 1 12.9067V11.2143C1 10.5113 1.24922 9.91249 1.74767 9.41775C2.24638 8.92327 2.85004 8.67603 3.55864 8.67603H9.46833L15.7435 4.98907V19.1319L9.46833 15.445H6.78772V21.4286H5.20367ZM14.1595 16.3336V7.78739L9.91305 10.2475H3.55864C3.31496 10.2475 3.09161 10.3482 2.88858 10.5496C2.68556 10.751 2.58405 10.9725 2.58405 11.2143V12.9067C2.58405 13.1485 2.68556 13.37 2.88858 13.5714C3.09161 13.7728 3.31496 13.8735 3.55864 13.8735H9.91305L14.1595 16.3336ZM18.5461 16.5996V7.52143C19.0763 8.0091 19.5033 8.64932 19.8272 9.44211C20.1512 10.2349 20.3131 11.1077 20.3131 12.0605C20.3131 13.0133 20.1512 13.8861 19.8272 14.6789C19.5033 15.4717 19.0763 16.1119 18.5461 16.5996Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesFlow);
export default __webpack_public_path__ + "static/media/SalesFlow.49c501b5fa26f0ed5de7f4c37c88fc8e.svg";
export { ForwardRef as ReactComponent };